import { useMemo } from 'react';

export function useAuthenticityToken() {
  const authenticityToken = useMemo(() => {
    const metaEl = document.querySelector('meta[name=csrf-token]');
    if (metaEl) {
      return metaEl.getAttribute('content');
    }
    return '';
  }, []);

  return authenticityToken;
}
